import { lazy } from 'react'

const Reports = lazy(() => import('../pages/reports'))
const Dashboard = lazy(() => import('../pages/dashboard'))



const ServiceTypes = lazy(() => import('../pages/settings/services-types'))
const ItemCategories = lazy(() => import('../pages/settings/item-categories'))
const PricePerKg = lazy(() => import('../pages/settings/price-per-kg'))
const Customers = lazy(() => import('../pages/customers'))
const Employees = lazy(() => import('../pages/employees'))
const Expenses = lazy(() => import('../pages/expenses'))
const Salaries = lazy(() => import('../pages/salaries'))
const Orders = lazy(() => import('../pages/orders'))
const Subscriptions = lazy(() => import('../pages/subscriptions'))
const SubscriptionOrders = lazy(() => import('../pages/subscriptionOrders'))
const AdminTenants = lazy(() => import('../pages/admin/tenants'))
const Users = lazy(() => import('../pages/users'))

const routes = [
  { path: '/orders', element: Orders },
  { path: '/reports', element: Reports },
  { path: '/customers', element: Customers },
  { path: '/employees', element: Employees },
  { path: '/salaries', element: Salaries },
  { path: '/expenses', element: Expenses },
  { path: '/subscriptions', element: Subscriptions },
  { path: '/subscription-orders', element: SubscriptionOrders },
  { path: '/admin/tenants', element: AdminTenants },
  { path: '/users', element: Users },
  {
    path: '/service-types',
    element: ServiceTypes
  },
  {
    path: '/item-categories',
    element: ItemCategories
  },
  {
    path: '/price-per-kg',
    element: PricePerKg
  },
]

export default routes
